import { Amendment, PageModel, PaymentData, PaidUpgrade } from 'types/expiryRenewal';

export function setPageModel(renewalJourneyDetails: PageModel) {
  return { type: 'SET_PAGEMODEL' as const, payload: renewalJourneyDetails };
}

export function setPolicyLockToken(token: string | null) {
  return { type: 'SET_LOCK_TOKEN' as const, payload: token };
}

export function setPaymentData(data: PaymentData) {
  return { type: 'SET_PAYMENT_DATA' as const, payload: data };
}

export function setAddOns(paidUpgrades: PaidUpgrade[]) {
  return { type: 'SET_ADDONS' as const, payload: paidUpgrades };
}

export function setRemovedExtras(productCodes: string[]) {
  return { type: 'SET_REMOVED_EXTRAS' as const, payload: productCodes };
}

export function setMonthlyFlex(bool: boolean) {
  return { type: 'SET_MONTHLY_FLEX' as const, payload: bool };
}

export function setAutoRenew(bool: boolean) {
  return { type: 'SET_AUTORENEW' as const, payload: bool };
}

export function setPaperless(bool: boolean) {
  return { type: 'SET_PAPERLESS' as const, payload: bool };
}

export function setBasket(totalPrice: number | null | undefined, wasPrice: number | null) {
  return { type: 'SET_BASKET' as const, payload: { totalPrice: totalPrice ?? null, wasPrice } };
}

export function setRenewalTermsAccepted(bool: boolean) {
  return { type: 'SET_RENEWAL_TERMS_ACCEPTED' as const, payload: bool };
}

export function setUseDefaultStepper(bool: boolean) {
  return { type: 'SET_USE_DEFAULT_STEPPER' as const, payload: bool };
}

export function setAmendments(amendments: Amendment[]) {
  return { type: 'SET_AMENDMENTS' as const, payload: amendments };
}

export type ExpiryRenewalAction =
  | ReturnType<typeof setPageModel>
  | ReturnType<typeof setPolicyLockToken>
  | ReturnType<typeof setPaymentData>
  | ReturnType<typeof setAddOns>
  | ReturnType<typeof setRemovedExtras>
  | ReturnType<typeof setMonthlyFlex>
  | ReturnType<typeof setAutoRenew>
  | ReturnType<typeof setPaperless>
  | ReturnType<typeof setBasket>
  | ReturnType<typeof setRenewalTermsAccepted>
  | ReturnType<typeof setUseDefaultStepper>
  | ReturnType<typeof setAmendments>;
